import { useTrackers } from '@ps/web-shared-analytics';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import { kebabCase } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGameInfoEnabled } from '@swf/casino';
import InfoIcon from '@swf/core/assets/casino/info.svg';
import { useWidget } from '@swf/core/hooks/useWidget';
import { type Dispatch, select } from '@swf/core/store';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import { MarketingTag } from '@swf/core/types/CasinoGame';

import styles from './GameInfoIcon.scss';

interface Props {
  className?: string;
  game?: CasinoGame;
  index?: number;
  count?: number;
}

const GameInfoIcon: React.FC<Props> = ({ className, count, game, index }) => {
  const isMobile = useSelector(select.device.isMobile);
  const { modal } = useDispatch<Dispatch>();
  const { trackInfo } = useTrackers();
  const infoEnabled = useGameInfoEnabled();
  const showGameInfoIcon = game?.tags && game?.tags.includes(MarketingTag.GameInfo);
  const { widgetId } = useWidget();

  const launchInfoPage = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    trackInfo(game as CasinoGame, index, count);
    modal.enqueue({ path: '/casino/game-info', locationState: { game, widgetId } });
  };

  return game?.name && infoEnabled && showGameInfoIcon ? (
    <Link
      className={classNames(
        styles.cornerButton,
        styles.info,
        className,
        isMobile && styles.infoIconMobile,
        game?.jackpot && styles.withJackpot
      )}
      onClick={launchInfoPage}
      alias="casinoGameInfo"
      title={game.name}
      track={false}
      values={{ name: kebabCase(game.name), gtype: game.gametype, vtype: game.variant }}
    >
      <InfoIcon />
    </Link>
  ) : null;
};

export default GameInfoIcon;
